import { ReactElement } from "react";

import {
    UniformSlot,
    UniformSlotWrapperComponentProps
} from "@uniformdev/canvas-react";

import { HeroCarousel } from "@/libraries/design/patterns/hero-carousel/src/hero-carousel";

const renderHeroCarousel: React.ComponentType<
    UniformSlotWrapperComponentProps
> = ({ items }) => {
    // First pass to work through Uniform setting empty to "" vs undefined that underlying component expects
    // eslint-disable-next-line complexity
    const transformed = items.map((heroSlide) => {
        const params = (heroSlide as ReactElement).props?.children?.props?.data
            ?.parameters;

        return {
            id: params.id?.value || undefined,
            eyebrow: params.tabEyebrow?.value || undefined,
            title: params?.tabLabel?.value || undefined,
            panel: {
                title: params.title?.value || undefined,
                body: params.body?.value || undefined,
                primaryCallToAction:
                    params.buttonText?.value && params.buttonHref?.value
                        ? {
                              "text": params.buttonText?.value,
                              "href": params.buttonHref?.value,
                              "aria-label":
                                  params.buttonAriaLabel?.value || undefined
                          }
                        : undefined,
                secondaryCallToAction:
                    params.linkText?.value && params.linkHref?.value
                        ? {
                              text: params.linkText?.value,
                              href: params.linkHref?.value,
                              type: params.linkType?.value || undefined,
                              ariaLabel:
                                  params.linkAriaLabel?.value || undefined
                          }
                        : undefined,
                bgColor: params.bgColor?.value || undefined,
                bgImage: {
                    lg: params.imageLarge?.value || undefined
                },
                layout: params.alignment?.value || undefined
            }
        };
    });

    return <HeroCarousel tabsData={transformed} />;
};

const UniformHeroCarousel = () => {
    return (
        <div>
            <UniformSlot name="tabdata" wrapperComponent={renderHeroCarousel} />
        </div>
    );
};

export default UniformHeroCarousel;
